export default {
  Start: 'START',
  Loading: 'LOADING',
  Processing: 'PROCESSING',
  Success: 'SUCCESS',
  Error: 'ERROR'
};
